// extracted by mini-css-extract-plugin
export var divider = "_en-7";
export var itemsToggle = "_en-8";
export var mergeModal = "_en-1";
export var optionCard = "_en-4";
export var radioGroup = "_en-6";
export var radioOption = "_en-0";
export var selected = "_en-5";
export var shipmentOptions = "_en-2";
export var tableOptions = "_en-3";